module.exports = __webpack_public_path__ + "img/bookmarks-24px.f52de6f4.svg";